import {
  AccessActionSchema,
  AccessScopeSchema,
} from '@cntxt/shared/infrastructure/prisma/schemas';

import { AccessRequired } from '../types';

export const adminRouteRequiredAccess: AccessRequired = {
  type: 'some',
  access: [
    {
      AccessScope: AccessScopeSchema.enum.ORG,
      scopeDomain: '',
      AccessAction: [AccessActionSchema.enum.ORG_CREATE],
    },
    {
      AccessScope: AccessScopeSchema.enum.ORG,
      scopeDomain: '',
      AccessAction: [AccessActionSchema.enum.MANAGE_ROLES],
    },
    {
      AccessScope: AccessScopeSchema.enum.ORG,
      scopeDomain: '',
      AccessAction: [AccessActionSchema.enum.SITE_CREATE],
    },
    {
      AccessScope: AccessScopeSchema.enum.ORG,
      scopeDomain: '',
      AccessAction: [AccessActionSchema.enum.ASSIGN_ROLES],
    },
    {
      AccessScope: AccessScopeSchema.enum.ORG,
      scopeDomain: '',
      AccessAction: [AccessActionSchema.enum.MANAGE_WORKFLOWS],
    },
    {
      AccessScope: AccessScopeSchema.enum.ORG,
      scopeDomain: '',
      AccessAction: [AccessActionSchema.enum.ASSIGN_WORKFLOW_ROLES],
    },
    {
      AccessScope: AccessScopeSchema.enum.SYSTEM,
      scopeDomain: '',
      AccessAction: [AccessActionSchema.enum.ORG_CREATE],
    },
    {
      AccessScope: AccessScopeSchema.enum.SYSTEM,
      scopeDomain: '',
      AccessAction: [AccessActionSchema.enum.MANAGE_ROLES],
    },
    {
      AccessScope: AccessScopeSchema.enum.SYSTEM,
      scopeDomain: '',
      AccessAction: [AccessActionSchema.enum.ORG_USERS_MANAGE],
    },
  ],
};
